//Toon mobile menu 
const menuIcon = document.getElementById('nav-menu-icon');
const mobileMenu = document.getElementById('nav-mobile-menu');
menuIcon.addEventListener('click',function(){
    this.classList.toggle("close");
    mobileMenu.classList.toggle("open");
    document.body.classList.toggle('no-scroll');

    const isExpandedMobile = menuIcon.getAttribute("aria-expanded") === "true";

    if (isExpandedMobile) {
        // Sluit het submenu
        menuIcon.setAttribute("aria-expanded", "false");
        mobileMenu.setAttribute("aria-hidden", "true");
    } else {
        // Open het geselecteerde submenu
        menuIcon.setAttribute("aria-expanded", "true");
        mobileMenu.setAttribute("aria-hidden", "false");
    }
});

// Sluit mobile menu bij esc button
document.body.addEventListener('keydown', function(e) {
    if (e.key == "Escape" && menuIcon.getAttribute("aria-expanded") === "true") {
        menuIcon.classList.toggle("close");
        mobileMenu.classList.toggle("open");
        menuIcon.setAttribute("aria-expanded", "false");
        mobileMenu.setAttribute("aria-hidden", "true");
    }
});

//voeg class toe on hover om kleur te geven aan hoofdnavigatie
document.querySelectorAll('.nav-level-1-item').forEach(item => {
    const button = item.querySelector('.nav-btn-item');
    const list = item.querySelector('.nav-level-2');

    if (button) {
        item.addEventListener('mouseenter', () => {
            button.setAttribute('aria-expanded', 'true');
            list.setAttribute('aria-hidden', 'false');
            item.classList.add('open-children');
        });

        item.addEventListener('mouseleave', () => {
            button.setAttribute('aria-expanded', 'false');
            list.setAttribute('aria-hidden', 'true');
            item.classList.remove('open-children');
        });
    }
});

document.querySelectorAll('.nav-level-2-item').forEach(item => {
    const button = item.querySelector('.nav-btn-subitem');
    const list = item.querySelector('.nav-level-3');

    if (button) {
        item.addEventListener('mouseenter', () => {
            button.setAttribute('aria-expanded', 'true');
            list.setAttribute('aria-hidden', 'false');
            item.classList.add('open-children');
        });

        item.addEventListener('mouseleave', () => {
            button.setAttribute('aria-expanded', 'false');
            list.setAttribute('aria-hidden', 'true');
            item.classList.remove('open-children');
        });
    }
});

document.querySelectorAll('.nav-level-3-item').forEach(level3Item => {
    const level2Item = level3Item.closest('.nav-level-2-item');

    if (level2Item) {
        level3Item.addEventListener('mouseenter', () => {
            level2Item.classList.add('open-children');
        });

        level3Item.addEventListener('mouseleave', () => {
            level2Item.classList.remove('open-children');
        });
    }
});

// WCAG desktopmenu
// Element selectors
const topButtons = document.querySelectorAll(".nav-main .nav-btn-item, .nav-main .nav-main-link-level-1");
const level2Links = document.querySelectorAll(".nav-main .nav-main-link-level-2");
const level3Buttons = document.querySelectorAll(".nav-main .nav-btn-subitem");
const level3Links = document.querySelectorAll(".nav-main .nav-main-link-level-3");

// Event listeners voor top-level buttons en links
topButtons.forEach((element, index, elements) => {
    element.addEventListener("keydown", (event) => handleTopMenuKey(event, element, index, elements));
    if (element.tagName === "BUTTON") {
        element.addEventListener("click", () => toggleSubNav(element));
    }
});

// Event listeners voor submenu links
level2Links.forEach((link) => {
    link.addEventListener("keydown", (event) => handleSubmenuKey(event, link));
});

level3Buttons.forEach((btn) => {
    btn.addEventListener("click", () => toggleSubNav(btn, true));
});

level3Links.forEach((link) => {
    link.addEventListener("keydown", (event) => handleSubmenuKey(event, link));
});

// key events voor top-level menu
function handleTopMenuKey(event, element, index, elements) {
    const key = event.key;

    switch (key) {
        case "ArrowRight":
            event.preventDefault();
            focusNext(elements, index);
            break;

        case "ArrowLeft":
            event.preventDefault();
            focusPrevious(elements, index);
            break;

        case "Enter":
        case " ":
            if (element.tagName === "BUTTON") {
                event.preventDefault();
                toggleSubNav(element);
            }
            break;

        case "ArrowDown":
            event.preventDefault();
            if (element.tagName === "BUTTON") {
                focusFirstSubmenuItem(element);
            }
            break;
    }
}

// Handle key events voor submenu links
function handleSubmenuKey(event, link) {
    const key = event.key;
    const parentMenu = link.closest("ul");

    switch (key) {
        case "ArrowDown":
            event.preventDefault();
            focusNextInMenu(link, parentMenu);
            break;

        case "ArrowUp":
            event.preventDefault();
            focusPreviousInMenu(link, parentMenu);
            break;

        case "Escape":
            event.preventDefault();
            closeSubMenu(link);
            break;
    }
}

// Navigation helpers
function focusNext(elements, currentIndex) {
    const nextIndex = (currentIndex + 1) % elements.length;
    elements[nextIndex].focus();
}

function focusPrevious(elements, currentIndex) {
    const prevIndex = (currentIndex - 1 + elements.length) % elements.length;
    elements[prevIndex].focus();
}

function focusFirstSubmenuItem(button) {
    const submenuId = button.getAttribute("aria-controls");
    const submenu = document.getElementById(submenuId);
    if (submenu && submenu.style.display === "block") {
        const firstItem = submenu.querySelector("a");
        if (firstItem) {
            firstItem.focus();
        }
    }
}

function focusNextInMenu(link, menu) {
    const nextItem = link.parentElement.nextElementSibling?.querySelector("a");
    if (nextItem) {
        nextItem.focus();
    }
}

function focusPreviousInMenu(link, menu) {
    const prevItem = link.parentElement.previousElementSibling?.querySelector("a");
    if (prevItem) {
        prevItem.focus();
    }
}

function focusParentButton(menu) {
    const controllingButton = document.querySelector(`button[aria-controls="${menu.id}"]`);
    if (controllingButton) {
        controllingButton.focus();
    }
}

// Menu toggle logica
function toggleSubNav(button, isSubSub = false) {
    const subMenuId = button.getAttribute("aria-controls");
    const subMenu = document.getElementById(subMenuId);
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const menuItem = subMenu.closest('.menu-item');

    if (isExpanded) {
        // Sluit het submenu
        button.setAttribute("aria-expanded", "false");
        subMenu.setAttribute("aria-hidden", "true");
        subMenu.classList.remove("open");
        if (menuItem) {
            menuItem.classList.remove("open-children");
        }
    } else {
        // Sluit andere submenus afhankelijk van niveau
        if (isSubSub) {
            closeAllSubSubmenus();
        } else {
            closeAllSubmenus();
        }

        // Open het geselecteerde submenu
        button.setAttribute("aria-expanded", "true");
        subMenu.setAttribute("aria-hidden", "false");
        subMenu.classList.add("open");
        if (menuItem) {
            menuItem.classList.add("open-children");
        }
    }

    // Focus op het eerste submenu-item
    const firstItem = subMenu.querySelector("a");
    if (firstItem) {
        firstItem.focus();
    }
}

function closeSubMenu(link) {
    const parentMenu = link.closest("ul");
    if (parentMenu) {
        const menuItem = parentMenu.closest('.menu-item');
        if (menuItem) {
            menuItem.classList.remove("open-children");
        }
        parentMenu.classList.remove("open");
        focusParentButton(parentMenu);
    }
}

function closeAllSubmenus() {
    document.querySelectorAll(".nav-main .open-children").forEach((menuItem) => {
        menuItem.classList.remove("open-children");
    });
    document.querySelectorAll(".nav-main .nav-level-2").forEach((menu) => {
        menu.classList.remove("open-children");
        menu.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll(".nav-main .nav-btn-item").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
    });
}

function closeAllSubSubmenus() {
    document.querySelectorAll(".nav-level-3.open").forEach((menu) => {
        menu.classList.remove("open");
        menu.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll(".nav-btn-subitem[aria-expanded='true']").forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
    });
}

// Sluit menu's bij klik buiten menu of Escape knop
document.addEventListener("click", (event) => {
    if (!event.target.closest(".nav-main")) {
        closeAllSubmenus();
    }
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
        closeAllSubmenus();
    }
});